import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { DataService } from "src/app/shared/services/data.service";
import { LanguageService } from "src/app/shared/services/language/language.service";
import { LoaderService } from "src/app/shared/services/loader/loader.service";
import {
  ResponseData,
  TeamDetails,
} from "src/app/shared/services/teacher.interface";

@Component({
  selector: "app-loby",
  templateUrl: "./loby.component.html",
  styleUrls: ["./loby.component.scss"],
})
export class LobyComponent implements OnInit {
  loginError: string = "";
  teamCode: string = "";
  groupId: string = "";
  groupIdExists = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private loader: LoaderService,
    private languageService: LanguageService,
    private router: Router,
    private dataService: DataService
  ) {
    sessionStorage.removeItem("GCTeamGroupId");
    sessionStorage.removeItem("GCTeamCode");
    // sessionStorage.removeItem('GCGroup');
    sessionStorage.removeItem("s_end_time");
  }

  ngOnInit(): void {
    history.pushState(null, null, window.location.href);
    //default language for student play set to 'nl'
    this.languageService.translateLanguge.next("nl");
    localStorage.setItem("userLang", "nl");
    this.translate.use("nl");
    this.activatedRoute.queryParams.subscribe((params) => {
      this.groupId = params["id"];
    });
  }

  joinGame() {
    if (!this.groupId) {
      this.groupIdExists = false;
      return;
    }
    if (this.teamCode.trim() != "") {
      this.loginError = "";
      this.loader.display(true);
      let body = {
        group_code: this.groupId,
        team_code: this.teamCode?.trim(),
      };
      this.groupIdExists = true;
      this.dataService.validateTeamCode(body).subscribe({
        next: (res: ResponseData<TeamDetails>) => {
          sessionStorage.setItem("GCTeamGroupId", this.groupId);
          sessionStorage.setItem("GCTeamCode", res.data.team_code);
          sessionStorage.setItem("GCGroup", res.data.id);
          sessionStorage.setItem("group", res.data.group);
          this.loader.display(false);
          if (res.data.status == 102) {
            this.router.navigateByUrl("/quiz");
          } else if (res.data.completed_time) {
            this.router.navigateByUrl("/quiz-finished");
          } else {
            this.router.navigateByUrl("/quiz-begin");
          }
        },
        error: (err: HttpErrorResponse) => {
          console.log(err);
          this.loginError = err.error?.detail?.detail;
          this.loader.display(false);
        },
      });
    }
  }
}
